var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94274 0.723066C9.3508 0.927096 9.68167 1.25797 9.8857 1.66603L15.7769 13.4485C16.2977 14.4901 15.8755 15.7566 14.834 16.2774C14.5412 16.4238 14.2183 16.5 13.891 16.5H2.10854C0.944025 16.5 0 15.556 0 14.3915C0 14.0641 0.0762133 13.7413 0.222604 13.4485L6.11384 1.66603C6.63462 0.624461 7.90116 0.20228 8.94274 0.723066ZM8 12.5C7.44772 12.5 7 12.9477 7 13.5C7 14.0523 7.44772 14.5 8 14.5C8.55229 14.5 9 14.0523 9 13.5C9 12.9477 8.55229 12.5 8 12.5ZM8 4.5C7.48716 4.5 7.06449 4.88604 7.00673 5.38338L7 5.5V9.5C7 10.0523 7.44772 10.5 8 10.5C8.51284 10.5 8.93551 10.114 8.99327 9.61662L9 9.5V5.5C9 4.94772 8.55229 4.5 8 4.5Z",
    fill: "#FC6A46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarning);
export default __webpack_public_path__ + "static/media/AlertWarning.bfc064865bb20c69367dd78a5db358ac.svg";
export { ForwardRef as ReactComponent };